import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const AppStore = {
  namespaced: true,
  state: {
    title: 'Bienvenido a Garage Argentino',
    subTitle: '',
    subTitles: [],
    backgroundClass: ''
  },
  getters,
  mutations,
  actions
}

export default AppStore
